import { ModalDialog } from "common/Dialog"
import { Form, FormField, PrimaryButton, SecondaryButton } from "common/Forms";
import { SelectInput } from "common/Forms/inputs";
import { ResponsiveGap } from "common/Grid";
import { Grid, GridCell } from "common/Grid/Grid";

const ImportProducts = ({value, setValue, isOpened, onCancel, importProductHandler, siteIdOptions}) =>
{
  return (
    <>
      <ModalDialog isOpened={isOpened} title='Import products' onClose={onCancel}>
        <ResponsiveGap left={false} right={false} top={false}>
          <Form>
            <FormField
              id="import_product_siteid"
              label='Site ID'
              inputFactory={(id, name, oninValidition) =>
                <SelectInput disabled={false}
                  id={id} name={name}
                  placeholder="Select site id"
                  selectedKey={value}
                  isClearable={false}
                  optionProvider={() => siteIdOptions}
                  keySelector={(x => `${x.value}`)}
                  labelSelector={(x => `${x.label}`)}
                  onValidation={oninValidition}
                  onChange={(_, n, selector) => setValue(n ? selector(n) : undefined)}/>
              } />
            {/* <FormField
              id={'import-file'}
              name={'fileUploadSetName'}
              inputFactory={(id, name, onValidation) =>
                <FileInput
                  error={error}
                  id={id} name={name}
                  placeholder="Import file"
                  onChange={(n) => onInputChange(n)}
                  onValidation={onValidation}
                  skipInitialValidation={false} />
              } /> */}
          </Form>
        </ResponsiveGap>
        <ResponsiveGap left={false} right={false} bottom={false}>
          <Grid columns={2}>
            <GridCell>
              <PrimaryButton isWide={true} action={() => importProductHandler()}>Import</PrimaryButton>
            </GridCell>
            <GridCell>
              <SecondaryButton action={() => onCancel()} isWide={true}>Cancel</SecondaryButton>
            </GridCell>
          </Grid>
        </ResponsiveGap>
      </ModalDialog>
    </>
  );
};

export default ImportProducts